module.exports = __webpack_public_path__ + "static/media/flags_responsive.73e6b012.png";